import { ExternalLinkIcon } from '@slal/ui/icons';
import { Modal, ModalBody } from '@slal/ui/modal';
import { Article, Heading, P, Text } from '@slal/ui/typography';
import { useCallback, useState } from 'react';
import { BookAppointmentButton, EqualHeightsCard, StyledLink } from './styles';

export const BookPensionWise = () => {
    const [isModalopen, setIsModalOpen] = useState(false);
    const closeModal = useCallback(() => setIsModalOpen(false), [setIsModalOpen]);
    const openModal = useCallback(() => setIsModalOpen(true), [setIsModalOpen]);

    const bookOnlineId = 'book-a-pension-wise-appointment-online';
    const bookPhoneId = 'book-a-pension-wise-appointment-phone';

    return (
        <>
            <Article>
                <P>
                    As you're planning to start taking money out of your pension, we strongly recommend talking to a
                    Pension Wise specialist or paying for financial advice. Seeking guidance can help you understand
                    your options and make an informed decision.
                </P>

                <P>
                    Pension Wise is a free, impartial guidance service backed by the Government, We can help you book an
                    appointment.
                </P>

                <BookAppointmentButton variant="outline" onClick={openModal}>
                    How to book an appointment
                </BookAppointmentButton>
            </Article>

            <Modal isOpen={isModalopen} onClose={closeModal} title="Booking a Pension Wise appointment">
                <ModalBody>
                    <Article>
                        <P>
                            Pension Wise is a free, impartial guidance service backed by the Government. You can book an
                            appointment with a pension specialist to talk through your retirement options.
                        </P>
                        <P>
                            If you'd like help booking a PensionWise appointment, call us on{' '}
                            <Text tag="strong">0345 266 8013</Text>. Call charges will vary.
                        </P>

                        <EqualHeightsCard aria-labelledby={bookOnlineId}>
                            <Heading level={4} id={bookOnlineId}>
                                Online
                            </Heading>

                            <P>The quickest way to book is online.</P>

                            <StyledLink
                                href="https://www.moneyhelper.org.uk/en/pensions-and-retirement/pension-wise/pension-wise-customers"
                                target="_blank"
                            >
                                Book an appointment
                                <ExternalLinkIcon />
                            </StyledLink>
                        </EqualHeightsCard>

                        <EqualHeightsCard aria-labelledby={bookPhoneId}>
                            <Heading level={4} id={bookPhoneId}>
                                Phone
                            </Heading>

                            <P>
                                Call Pension Wise for free on <Text tag="strong">0800 100 166</Text>.
                            </P>
                        </EqualHeightsCard>
                    </Article>
                </ModalBody>
            </Modal>
        </>
    );
};
